export default __webpack_public_path__ + "static/media/bh-on-mount.81986281.gif";